import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { simplifyTradingVolume } from "../../../helpers/helper";
import { useSelector } from "react-redux";

function TradingCards({stats }) {
  
  const user=useSelector(state=>state.user.user);
  return (
    <div className={`sliderWrap ${user?.role==="member" ? "mw-100" : ""}`}>
      <Swiper
        slidesPerView={4}
        spaceBetween={15}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          250: { slidesPerView: 1 },
          300: { slidesPerView: 2 },
          401: { slidesPerView: 2.5 },
          576: { slidesPerView: 3 },
          767: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          945: { slidesPerView: 4 },
          946: { slidesPerView: 4 },
          1050: { slidesPerView: 4 },
          1051: { slidesPerView: 3 },
          1300: { slidesPerView: 3 },
          1301: { slidesPerView: 4 },
        }}
        modules={[Pagination, Autoplay]}
        className="tradingCardSilderwrap"
      >
        <SwiperSlide>
          <div className="tradingCard">
            <p className="cardTitle">DAILY AVG. PROFIT</p>
            <p className="cardNumber">{stats?.dailyAvgProfit || 0}%</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="tradingCard">
            <p className="cardTitle">Avg. Trade ROI</p>
            <p className="cardNumber">{`${simplifyTradingVolume(stats?.roi)}%`}</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="tradingCard">
            <p className="cardTitle">Win Rate</p>
            <p className="cardNumber">{stats?.winRate || 0}%</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="tradingCard">
            <p className="cardTitle">Group Trading Volume</p>
            <p className="cardNumber">{stats?.tradingVolumeLastMonth || 0}</p>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default TradingCards;
